// Pure freemium gate decision (PLAN §5, Increment 4) — no network, unit-tested
// like selectHero. The server RPC (consume_free_play) is the authoritative gate;
// this decides client-side routing + whether the Members lock chip shows.

export type WatchDecision = 'play' | 'upgrade' | 'signin';

export function decideWatch(input: {
  kind: 'vod' | 'live';
  signedIn: boolean;
  isMember: boolean;
  unlocked?: boolean; // vod: title already played this calendar month
  remaining?: number; // vod: distinct plays left this month
}): WatchDecision {
  // Anon → sign-in (not the invite-only sign-up): returning users (incl.
  // cohosts) have accounts; the sign-in page links to sign-up for new people.
  if (!input.signedIn) return 'signin';
  if (input.isMember) return 'play';
  if (input.kind === 'live') return 'upgrade'; // members-only; no free-play counter
  if (input.unlocked || (input.remaining ?? 0) > 0) return 'play';
  return 'upgrade';
}

/** Map a decision to its destination href. `play` keeps the given watch path. */
export function watchDestination(decision: WatchDecision, watchHref: string): string {
  switch (decision) {
    case 'play':
      return watchHref;
    case 'upgrade':
      return '/subscribe';
    case 'signin':
      // Carry the watch path so sign-in returns the viewer to the video they
      // clicked (the Spec 06/13 `next` plumbing, now serving the app's own
      // front room). `upgrade → /subscribe` stays app-internal (Spec 12).
      return `/auth/sign-in?next=${encodeURIComponent(watchHref)}`;
  }
}
